
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/menu",
      function () {
        return require("private-next-pages/account/menu/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/menu"])
      });
    }
  